import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import messages from './translations.js';

import '@/assets/fabric11.min.css';
import '@/assets/fabric.min.css';
import "font-awesome/css/font-awesome.min.css";
import "umaui/dist/style.css";


const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const idioma = urlParams.get("IDM")?.toLowerCase() || "pt";
 
export const i18n = createI18n({
  messages,
  locale: idioma, // set locale
})

const pinia = createPinia()
const app = createApp(App)
app.use(pinia);
app.use(i18n);
app.config.unwrapInjectedRef = true;
app.mount('#app')
